var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1278 52.1981C38.945 53.1515 39.9545 52.5234 39.9433 49.8874V38.9731H49.4666C50.4018 38.9731 51.2988 38.6024 51.9611 37.9422C52.6235 37.282 52.997 36.3861 53 35.451V33.0056V30.5491C52.9985 30.0865 52.906 29.6288 52.7276 29.2021C52.5492 28.7753 52.2886 28.3878 51.9605 28.0618C51.6323 27.7358 51.2432 27.4776 50.8153 27.3019C50.3875 27.1263 49.9292 27.0367 49.4666 27.0381H39.9321V16.9427C39.9321 12.7363 38.2271 13.0504 36.2865 14.0936L13.9981 30.8856C13.7311 31.1128 13.5151 31.3938 13.3642 31.7103C13.2133 32.0267 13.1309 32.3715 13.1224 32.7219C13.114 33.0724 13.1796 33.4208 13.315 33.7441C13.4505 34.0675 13.6527 34.3586 13.9084 34.5985L37.1278 52.1981Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0062 51.0072C37.8234 51.9606 38.8329 51.3325 38.8217 48.6965V37.7822H48.345C49.2802 37.7822 50.1772 37.4115 50.8396 36.7513C51.5019 36.0911 51.8754 35.1952 51.8784 34.26V31.8147V29.3582C51.8769 28.8956 51.7844 28.4379 51.606 28.0111C51.4277 27.5844 51.167 27.1969 50.8389 26.8709C50.5108 26.5449 50.1217 26.2867 49.6938 26.111C49.2659 25.9354 48.8076 25.8457 48.345 25.8472H38.8105V15.7518C38.8105 11.5454 37.1055 11.8595 35.1649 12.9027L12.8765 29.6947C12.6095 29.9219 12.3935 30.2029 12.2426 30.5193C12.0917 30.8358 12.0093 31.1805 12.0009 31.531C11.9924 31.8815 12.058 32.2298 12.1935 32.5532C12.3289 32.8766 12.5311 33.1677 12.7868 33.4075L36.0062 51.0072Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/back.4031cb0c.svg";
export { SvgBack as ReactComponent };